import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { LoadingService } from '@core/services/loading.service';
import { ToastService } from '@core/services/toast.service';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { ToastComponent, ToastConfig, ToastPosition } from '@shared/ui/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, LoadingComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly loadingService = inject(LoadingService);
  private readonly toastService = inject(ToastService);
  protected readonly toasts = toSignal(this.toastService.toasts$, { initialValue: [] });

  protected filterToasts(toasts: ToastConfig[], position: ToastPosition): ToastConfig[] {
    return toasts.filter((t) => t.position === position);
  }

  protected trackToast(_index: number, toast: ToastConfig): string {
    return toast.id;
  }

  protected removeToast(id: string): void {
    this.toastService.removeToast(id);
  }
}
